import { POST_SIGN_UP } from 'root/src/shared/descriptions/endpoints/endpointIds'
import { gatewayEndpointType } from 'root/src/shared/descriptions/endpoints/lenses'

export default {
	[POST_SIGN_UP]: {
		endpointType: gatewayEndpointType,
	},
}
